<mat-card [ngClass]="{ hide: !medicineVisable, 'form-ui': true }">
  <mat-card-title>Stocktake</mat-card-title>
  <form class="mt-3">
    <div [formGroup]="stocktakeForm">
      <div class="row">
        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Search for medicine</mat-label>
              <input
                required
                [disabled]="isLoading"
                type="text"
                placeholder="Search for medicine"
                aria-label="Search for medicine"
                matInput
                formControlName="medicine"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                (optionSelected)="medicineSelected($event)"
                autoActiveFirstOption
                #auto="matAutocomplete"
              >
                <mat-option *ngFor="let med of medicine" [value]="med">
                  {{ med.name }}
                </mat-option>
              </mat-autocomplete>
              <mat-icon matPrefix>search</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Select package type</mat-label>
              <mat-select
                required
                [disabled]="
                  isLoading || medicineDosageTypePackageTypes.length === 0
                "
                formControlName="packageTypeId"
              >
                <mat-option
                  *ngFor="let type of medicineDosageTypePackageTypes"
                  value="{{ type.id }}"
                >
                  {{ type.package_type.type }} ({{ type.contained_quantity }})
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
        </div>

        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Dosage type</mat-label>
              <mat-select
                required
                [disabled]="isLoading || !selectedMedicine"
                formControlName="dosageTypeId"
                (selectionChange)="getMedicineDosagePackageTypes($event)"
              >
                <mat-option
                  [disabled]="type.is_active === 0"
                  *ngFor="let type of dosageTypes"
                  [value]="type.id"
                >
                  {{ type.additional_information }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="stocktakeForm.get('dosageTypeId')?.invalid">
                dosage type is invalid
              </mat-error>
            </mat-form-field>
          </p>
        </div>
      </div>
    </div>
  </form>
  <mat-card-actions align="end">
    <button color="primary" mat-raised-button (click)="setItem()">
      <mat-icon>assignment</mat-icon> Start scanning
    </button>
  </mat-card-actions>
</mat-card>

<mat-card [ngClass]="{ hide: !barcodeVisable, 'form-ui': true }">
    <mat-card-title>Stocktake</mat-card-title>
    <div class="col-md-3">
        Medicine - {{this.stocktakeForm.value.medicine}}
    </div>
    <div class="col-md-3">
        Dosage type - {{dosageTypeName}}
    </div>
    <div class="col-md-3">
        Package type - {{ packageTypeName?.package_type?.type }} ({{ packageTypeName?.contained_quantity }})
    </div>
   
  <form class="mt-3">
    <div [formGroup]="barcodeForm">
      <p class="barcode">
        <mat-form-field appearance="outline" [ngClass]="{ hide: !doneScanVisable }">
          <mat-label>Barcode</mat-label>
          <input
            [disabled]="barcodeDisabled"
            required
            matInput
            id="barcodeInput"
            [formControl]="barcodeValidate"
            placeholder="Barcode"
            #barcodeInput
          />
          
          <button
            (click)="checkBarcode()"
            title="Click to scan"
            matSuffix
            class="me-2 hide-button"
            mat-icon-button
          >
            click to scan
          </button>
          <mat-error *ngIf="barcodeValidate.invalid">
            Barcode is not valid
          </mat-error>
          <mat-hint>Examples AMI001001, BOLT02523, ABC2345-003</mat-hint>
        </mat-form-field>
      </p>
    </div>

    <mat-card-content>Scan Count : {{ scanCount }}</mat-card-content>
  </form>
  <mat-card-actions align="end" [ngClass]="{ hide: !doneScanVisable }" >
    <button color="primary" mat-raised-button (click)="checkData()">
      <mat-icon>assignment</mat-icon> Done
    </button>
  </mat-card-actions>

  <div [ngClass]="{ hide: !additionalInfoVisable }">
    <form class="form-ui">
      <div [formGroup]="additionalInfoForm" style="width: 90%;">
        <h4>Additional information</h4>
        <quill-editor
          formControlName="additional_information"
          format="text"
          [styles]="{ minHeight: '100px'}"
        >
        </quill-editor>
      </div>
    </form>
    <mat-card-actions align="end">
      <button color="primary" mat-raised-button (click)="submitData()">
        <mat-icon>assignment</mat-icon> Save
      </button>
    </mat-card-actions>
  </div>
</mat-card>
